module.exports = __webpack_public_path__ + "img/rlogo-old.ac0446ba.png";